import { TextField, NumberInput } from "react-admin";

import BusinessIcon from "@mui/icons-material/Business";
import { JsonField } from "../../ra-lb-tools/components/jsonField";
import { MyList } from "../../ra-lb-tools/components/myList";
import { OrganizationField, OrganizationInput } from "./organizations";
import { ProductField, ProductInput } from "./products";
import { PlanSubscriptionField } from "./plan_subsciptions";
import { MyDateField } from "../../ra-lb-tools/components/myDateField";

export const SystemIcon = BusinessIcon;
export const LockerUsageRecordsList = (props) => {
  const filters = [
    <OrganizationInput source="organizationId" alwaysOn key={2} />,
    <ProductInput source="productId" alwaysOn key={3} />,
    <NumberInput source="planSubscriptionId" alwaysOn key={4} />,
  ];

  const title = "Locker Usage Records";
  const resource = "locker-usage-records";

  return (
    <MyList
      title={title}
      resource={resource}
      sort={{
        field: "id",
        order: "DESC",
      }}
      filters={filters}
      {...props}
    >
      <TextField source="id" />
      <MyDateField source="fromDt" showTime />
      <MyDateField source="toDt" showTime />
      <TextField source="quantity" />
      <ProductField source="productId" />
      <PlanSubscriptionField source="planSubscriptionId" />
      <OrganizationField source="organizationId" />
      <TextField source="processorItemId" />
      <TextField source="processorMeterId" />
      <JsonField source="meterEventSent" />
      <JsonField source="meterEventSentErrors" />
      <MyDateField source="createdAt" showTime />
      <MyDateField source="updatedAt" showTime />
    </MyList>
  );
};
